import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuSidebar } from './menu-sidebar/menu-sidebar';
import { Header } from './header/header';

import { MatDialogContent } from "@angular/material/dialog";
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { LogoutPopup } from './logout-popup/logout-popup';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { ForgotPasswordSuccessPopup } from './forgot-password-success-popup/forgot-password-success-popup';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ResetPasswordSuccessPopup } from './reset-password-success-popup/reset-password-success-popup';
import { DeletePopup } from './delete-popup/delete-popup';
import { StatusChangePopup } from './status-change-popup/status-change-popup';
import { AuthenticationSuccessPopup } from './authentication-success-popup/authentication-success-popup';
import { MatSortModule } from '@angular/material/sort';
import { UserDetails } from './user-details/user-details';
import { ChangePassword } from './change-password/change-password';
import { ChangePasswordSuccessPopup } from './change-password-success-popup/change-password-success-popup';
import { SyncSetSuccessPopup } from './sync-set-success-popup/sync-set-success-popup';
import { SyncSetConfirmationPopup } from './sync-set-confirmation-popup/sync-set-confirmation-popup';
import { SyncCardConfirmationPopup } from './sync-card-confirmation-popup/sync-card-confirmation-popup';
import { CardSuccessPopup } from './card-success-popup/card-success-popup';
import { AddQuantityPopup } from './add-quantity-popup/add-quantity-popup';
import { NotificationConfirmPopup } from './notification-confirm-popup/notification-confirm-popup';
import { ManufacturePopup } from './manufacture-popup/manufacture-popup';
import { DeleteNfcUrlPopup } from './delete-nfc-url-popup/delete-nfc-url-popup';
import { DocumentPreviewModal } from './document-preview-modal/document-preview-modal';
import { ResolveTicketConfirmationPopup } from './resolve-ticket-confirmation-popup/resolve-ticket-confirmation-popup';
import { RejectTicketConfirmationPopup } from './reject-ticket-confirmation-popup/reject-ticket-confirmation-popup';
import { CardImagePreviewModal } from './card-image-preview-modal/card-image-preview-modal';
import { VerifySetPopup } from './verify-set-popup/verify-set-popup';
import { HasPermissionDirective } from '../directive/has-permission/has-permission.directive';

@NgModule({
  declarations: [
    MenuSidebar,
    Header,
    LogoutPopup,
    ForgotPasswordSuccessPopup,
    ResetPasswordSuccessPopup,
    DeletePopup,
    StatusChangePopup,
    AuthenticationSuccessPopup,
    UserDetails,
    ChangePassword,
    ChangePasswordSuccessPopup,
    SyncSetSuccessPopup,
    SyncSetConfirmationPopup,
    SyncCardConfirmationPopup,
    CardSuccessPopup,
    AddQuantityPopup,
    NotificationConfirmPopup,
    ManufacturePopup,
    DeleteNfcUrlPopup,
    DocumentPreviewModal,
    ResolveTicketConfirmationPopup,
    RejectTicketConfirmationPopup,
    VerifySetPopup,
    HasPermissionDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatDialogContent,
    MatButtonModule,
    MatTabsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatMenuModule,
    FormsModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatRadioModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    MatExpansionModule,
    MatStepperModule,
    MatTimepickerModule,
    MatIcon,
    MatSelectModule,
    MatDatepickerModule, MatSortModule,
    CardImagePreviewModal
  ],
  providers: [
    provideNativeDateAdapter()
  ],
  exports: [
    CommonModule,
    Header,
    MenuSidebar,
    CommonModule,
    RouterModule,
    MatDialogContent,
    MatButtonModule,
    MatTabsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatMenuModule,
    FormsModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatRadioModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    MatExpansionModule,
    MatStepperModule,
    MatTimepickerModule,
    MatIcon,
    MatSelectModule,
    MatDatepickerModule,
    DocumentPreviewModal,
    CardImagePreviewModal,
    HasPermissionDirective
  ],
})

export class SharedModule { }